"use client";

import { NuqsAdapter } from "nuqs/adapters/next/app";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";

export default function RootProviders(props: Readonly<{ children: React.ReactNode }>) {
  const [queryClient] = useState(function createQueryClient() {
    return new QueryClient({
      defaultOptions: {
        queries: { refetchInterval: 2 * 60e3, staleTime: 2 * 60e3, gcTime: 3 * 60e3 },
      },
    });
  });

  return (
    <NuqsAdapter>
      <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>
    </NuqsAdapter>
  );
}
